module.exports = "/_next/static/images/genesis-82325dbcd38c93667a39d8ec2d92a4a5.png";